import Api from './../api'
import DataLayer from './../data-layer/index'

DataLayer.$extend('episodes', {
    getByDate(channel, startdate, enddate) {
        return Api.episodes.find({ channel, startdate: startdate.toISOString(), enddate: enddate.toISOString() })
    },
})
